import { combineReducers } from "redux";
import calendarsReducer from "./calendars-reducer";

const reducers = combineReducers({
    calendars: calendarsReducer
});

export default reducers;